/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownIcon20Solid = forwardRef('ArrowADownIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m11.25 15.263 4.429-4.428a1.25 1.25 0 0 1 1.767 1.768l-5.236 5.236a3.125 3.125 0 0 1-4.42 0l-5.236-5.236a1.25 1.25 0 0 1 1.767-1.768l4.429 4.428V2.5a1.25 1.25 0 1 1 2.5 0v12.763Z" })));
});
